// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getStatement = createAsyncThunk('statementSliceData/getStatement', async () => {
    try {
        let response = await axios.get('/Report/bank-statement', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteCurrency = createAsyncThunk('statementSliceData/deleteCurrency', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Currency/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency deleted successfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createStatement = createAsyncThunk('statementSliceData/createStatement', async (data, { dispatch }) => {
    console.log(data, 'datas');
    try {
        let response = await axios.post('/Report', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Currency added succesfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCurrency = createAsyncThunk('statementSliceData/updateCurrency', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Currency/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency updated succesfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const statementSlice = createSlice({
    name: 'statementSliceData',
    initialState: {
        statement: []
    },
    extraReducers: (builder) => {
        builder.addCase(getStatement.fulfilled, (state, action) => {
            state.statement = action?.payload;
            return;
        });
    }
});

export default statementSlice.reducer;
